import { Spinner } from "@holigral/shared/ui/components/ui/spinner"
import { cn } from "@holigral/shared/ui/lib/utils"

type Props = {
  /** Spinning and visible while true, `display: none` while false */
  readonly busy: boolean
  readonly className?: string
}

/**
 * The in-button progress spinner. Always present in the DOM and merely
 * hidden while idle — never conditionally rendered.
 *
 * `{busy && <Spinner />}` next to a label looks equivalent but is not: when
 * busy flips, React inserts the spinner *before the label's text node*, and
 * page translators (Google Translate above all) re-parent text nodes into
 * their own <font> wrappers. The remembered anchor is then no longer a child
 * of the button, insertBefore throws NotFoundError, and React tears the whole
 * root down — a blank page mid-questionnaire. See
 * docs/dev/adr/0013-stable-dom-under-page-translation.md.
 */
export default function BusySpinner({ busy, className }: Props) {
  return <Spinner className={cn(!busy && "hidden", className)} />
}
